const update_status = ( section, node ) =>
{
  addPost(node.textContent, user.name ? user.name : 'Anonymous')
}

const social_status = new Search( { data: status_data, results_selector: '#js-social-status-results', search_selector: '#js-social-status', results_attr: 'statusresults', callback: update_status, no_results_msg: 'Your post doesn’t match our predetermined status update...' } );

